import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';

@Component({
    selector: 'app-sasa',
    templateUrl: './sasa.component.html',
    styleUrls: ['./sasa.component.css']
})
export class SasaComponent implements OnInit {

    roleData: any = {};
    mobile: string;
    partnerId: string;
    //for disabling div  in production
    constructor(private router: Router, private _location: Location) {
   
    }

    ngOnInit() {
        console.log(environment.pam2Url)
        this.roleData = JSON.parse(localStorage.getItem('role_pam'));
        this.mobile=localStorage.getItem('mobileNumber')
        if(this.mobile=='9599618041' || this.mobile=='9958050524' || this.mobile=='9654920144' || this.mobile=='8607377892' || this.mobile=='7232863914' || this.mobile=='8802556818' || this.mobile=='8802335883'){
            
            if (environment.production) {
                this.partnerId = "1102";
              } else {
                this.partnerId = "1079";
              }
        }
    }

    redirectoAgentMotor() {
        if(this.partnerId){
            window.open(environment.pam2Url + '/individual-insurance/motor-car-insurance-policy?rm=' + this.roleData.pamUserID + "&&partnerId="+this.partnerId);

        }
        else{
            window.open(environment.pam2Url + '/individual-insurance/motor-car-insurance-policy?rm=' + this.roleData.pamUserID);

        }
    }

    redirectoAgentFHI() {
        if(this.partnerId){
            window.open(environment.pam2Url + '/individual-insurance/family-health-insurance?rm=' + this.roleData.pamUserID+ "&&partnerId="+this.partnerId);
         }
        else{
            window.open(environment.pam2Url + '/individual-insurance/family-health-insurance?rm=' + this.roleData.pamUserID);
          }
    }

    redirectoTermLifeInsurance() {
        window.open('https://www.maxlifeinsurance.com/term-insurance-plans/get-quote?utmCode=143727634&utm_source=CorporateJourney&utm_medium=GroupBroker&utm_campaign=Secure%20Now%20Broker&utm_content=143727634');
    }

    redirectoMarine() {
        if(this.partnerId){
            window.open(environment.pam2Url + '/marine-insurance/transit-insurance-online?rm=' + this.roleData.pamUserID+ "&&partnerId="+this.partnerId);
    }
        else{
            window.open(environment.pam2Url + '/marine-insurance/transit-insurance-online?rm=' + this.roleData.pamUserID);
        }
    }

    redirectoAgentTraveInsurance(){
        if(this.partnerId){
            window.open(environment.pam2Url + '/individual-insurance/daily-hospital-cash?rm=' + this.roleData.pamUserID+ "&&partnerId="+this.partnerId);
        }
        else{
            window.open(environment.pam2Url + '/individual-insurance/daily-hospital-cash?rm=' + this.roleData.pamUserID);
          
        }
       //this.router.navigate(['/hospital-cash']);
    }

    
    redirectoAgentPropertyInsurance(){
        if(this.partnerId){
            window.open(environment.pam2Url + '/individual-insurance/personal-accident-insurance?rm=' + this.roleData.pamUserID+ "&&partnerId="+this.partnerId);
   
        }
        else{
            
        }
        window.open(environment.pam2Url + '/individual-insurance/personal-accident-insurance?rm=' + this.roleData.pamUserID);
    }

    redirectoAgentDPI() {
        if(this.partnerId){
            window.open(environment.pam2Url + '/profession/doctor-professional-indemnity-insurance?rm=' + this.roleData.pamUserID+ "&&partnerId="+this.partnerId);
   
        }
        else{
            window.open(environment.pam2Url + '/profession/doctor-professional-indemnity-insurance?rm=' + this.roleData.pamUserID);
   
        }
   }

    redirectoAgentWC() {
        if(this.partnerId){
            window.open(environment.pam2Url + '/group-insurance/workmen-compensation-insurance?rm=' + this.roleData.pamUserID+ "&&partnerId="+this.partnerId);
    
        }
        else{
            window.open(environment.pam2Url + '/group-insurance/workmen-compensation-insurance?rm=' + this.roleData.pamUserID);
    
        }
   }


}